"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCreateCryptoExchange = void 0;
var _lodash = _interopRequireDefault(require("lodash.get"));
var _reactRedux = require("react-redux");
var _actions = require("../../actions");
var _useSelector = require("../useSelector");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var useCreateCryptoExchange = function useCreateCryptoExchange(params) {
  var _params$action, _params$statePath;
  var action = (_params$action = params === null || params === void 0 ? void 0 : params.action) !== null && _params$action !== void 0 ? _params$action : _actions.createCryptoExchangeAction;
  var statePath = (_params$statePath = params === null || params === void 0 ? void 0 : params.statePath) !== null && _params$statePath !== void 0 ? _params$statePath : 'lib.exchange.createCrypto';
  var state = (0, _useSelector.useSelector)(function (state) {
    return (0, _lodash.default)(state, statePath);
  });
  var dispatch = (0, _reactRedux.useDispatch)();
  return {
    cryptoExchangeState: {
      done: state.done,
      loading: state.loading,
      feeLessThanRequired: state.feeLessThanRequired
    },
    createCryptoExchange: function createCryptoExchange(params) {
      return dispatch(action(params));
    },
    resetCryptoExchange: function resetCryptoExchange() {} // TODO add reset
  };
};
exports.useCreateCryptoExchange = useCreateCryptoExchange;